export default __webpack_public_path__ + "app/images/user/img-customer-service-03.png";